export default {
  'app.settings.menuMap.basic': 'Paramètres de base',
  'app.settings.menuMap.security': 'Paramètres de sécurité',
  'app.settings.menuMap.binding': 'Liaison de comptes',
  'app.settings.menuMap.notification': 'Notifications de nouveaux messages',
  'app.settings.basic.avatar': 'Avatar',
  'app.settings.basic.change-avatar': "Changer l'avatar",
  'app.settings.basic.email': 'E-mail',
  'app.settings.basic.email-message': 'Veuillez saisir votre e-mail !',
  'app.settings.basic.nickname': 'Surnom',
  'app.settings.basic.nickname-message': 'Veuillez saisir votre surnom !',
  'app.settings.basic.profile': 'Profil personnel',
  'app.settings.basic.profile-message':
    'Veuillez saisir votre profil personnel !',
  'app.settings.basic.profile-placeholder':
    'Une brève présentation de vous-même',
  'app.settings.basic.country': 'Pays/Région',
  'app.settings.basic.country-message': 'Veuillez saisir votre pays !',
  'app.settings.basic.geographic': 'Province ou ville',
  'app.settings.basic.geographic-message': 'Veuillez saisir votre région !',
  'app.settings.basic.address': 'Adresse postale',
  'app.settings.basic.address-message': 'Veuillez saisir votre adresse !',
  'app.settings.basic.phone': 'Numéro de téléphone',
  'app.settings.basic.phone-message': 'Veuillez saisir votre téléphone !',
  'app.settings.basic.update': 'Mettre à jour les informations',
  'app.settings.security.strong': 'Fort',
  'app.settings.security.medium': 'Moyen',
  'app.settings.security.weak': 'Faible',
  'app.settings.security.password': 'Mot de passe du compte',
  'app.settings.security.password-description':
    'Force actuelle du mot de passe',
  'app.settings.security.phone': 'Téléphone de sécurité',
  'app.settings.security.phone-description': 'Téléphone lié',
  'app.settings.security.question': 'Question de sécurité',
  'app.settings.security.question-description':
    "La question de sécurité n'est pas configurée, cette politique permet de protéger efficacement la sécurité du compte",
  'app.settings.security.email': 'E-mail de secours',
  'app.settings.security.email-description': 'E-mail lié',
  'app.settings.security.mfa': 'Appareil MFA',
  'app.settings.security.mfa-description':
    'Appareil MFA non lié ; une fois lié, une double confirmation sera requise',
  'app.settings.security.modify': 'Modifier',
  'app.settings.security.set': 'Définir',
  'app.settings.security.bind': 'Lier',
  'app.settings.binding.taobao': 'Lier Taobao',
  'app.settings.binding.taobao-description':
    'Compte Taobao non lié actuellement',
  'app.settings.binding.alipay': 'Lier Alipay',
  'app.settings.binding.alipay-description':
    'Compte Alipay non lié actuellement',
  'app.settings.binding.dingding': 'Lier DingTalk',
  'app.settings.binding.dingding-description':
    'Compte DingTalk non lié actuellement',
  'app.settings.binding.bind': 'Lier',
  'app.settings.notification.password': 'Mot de passe du compte',
  'app.settings.notification.password-description':
    'Les messages des autres utilisateurs seront notifiés via la messagerie interne',
  'app.settings.notification.messages': 'Messages système',
  'app.settings.notification.messages-description':
    'Les messages système seront notifiés via la messagerie interne',
  'app.settings.notification.todo': 'Notifications de tâches',
  'app.settings.notification.todo-description':
    'La liste des tâches à faire sera notifiée via la messagerie interne',
  'app.settings.open': 'Activer',
  'app.settings.close': 'Désactiver',
};
